module.exports = __webpack_public_path__ + "static/bg1-1349f9b8e388da0b547473086585a014.png";